exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content.front{background:#fbf4d2}.content.front span.beehive{width:42px;height:50px;transform:matrix(0,1,-1,0,0,0);background:#ffef45 0 0 no-repeat padding-box;position:relative;margin-right:7px;top:-5px}.content.front span.beehive img{max-width:100%;width:30px}@media (max-width:320px){footer.front .policy a.link{margin-right:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f9493b9","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Front/Body/index.vue
// module id = 1142
// module chunks = 0